import { render } from "./Services.vue?vue&type=template&id=24f9d4ee&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=24f9d4ee&scoped=true&lang=css"

import exportComponent from "/home/raulgarcia/Escritorio/projects/Vue/capwashmx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f9d4ee"]])

export default __exports__